import { isOfType } from "../../../utils";

// https://citrineinformatics.github.io/taurus-documentation/specification/attribute-templates/#real-bounds
export interface IRealBounds {
  type: "real_bounds";
  // note: all snake_case is converted to camelCase for the frontend
  default_units: string;
  lower_bound: number;
  upper_bound: number;
}

// https://citrineinformatics.github.io/taurus-documentation/specification/attribute-templates/#integer-bounds
export interface IIntegerBounds {
  type: "integer_bounds";
  lower_bound: number;
  upper_bound: number;
}

// https://citrineinformatics.github.io/taurus-documentation/specification/attribute-templates/#categorical-bounds
export interface ICategoricalBounds<Categories extends string[] = string[]> {
  type: "categorical_bounds";
  categories: Categories;
}

// https://citrineinformatics.github.io/taurus-documentation/specification/attribute-templates/#composition-bounds
export interface ICompositionBounds<Components extends string[] = string[]> {
  type: "composition_bounds";
  components: Components;
}

// https://citrineinformatics.github.io/taurus-documentation/specification/attribute-templates/#molecular-structure-bounds
export interface IMolecularStructureBounds {
  type: "molecular_structure_bounds";
}

export type IBounds =
  | IRealBounds
  | IIntegerBounds
  | ICategoricalBounds
  | ICompositionBounds
  | IMolecularStructureBounds;
export type BoundsType = IBounds["type"];

export const isRealBounds = isOfType<IRealBounds>("real_bounds");
export const isIntegerBounds = isOfType<IIntegerBounds>("integer_bounds");
export const isCategoricalBounds =
  isOfType<ICategoricalBounds>("categorical_bounds");
export const isCompositionBounds =
  isOfType<ICompositionBounds>("composition_bounds");
export const isMolecularStructureBounds = isOfType<IMolecularStructureBounds>(
  "molecular_structure_bounds",
);
